import { NotesTextEditor, NotesTextEditorProps } from '@factorialco/f0-react/dist/experimental'

import { useImageUploadForEditor } from 'modules/core/hooks/useImageUploadForEditor'

export interface NotesTextEditorWithUploadProps
  extends Omit<NotesTextEditorProps, 'imageUploadConfig'> {
  resourceType: string
  resourceId: string
}

export const NotesTextEditorWithUpload = ({
  resourceType,
  resourceId,
  ...props
}: NotesTextEditorWithUploadProps) => {
  const { onUpload } = useImageUploadForEditor({ resourceType, resourceId })

  return <NotesTextEditor {...props} imageUploadConfig={{ onUpload }} />
}
